import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseSearchDto } from '../../../shared/modules/base/dtos/base-search.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { PricingTierItemDto } from '../../../shared/modules/pricing-tier-items/dtos/pricing-tier-item.dto';
import { VehicleCategoryAvailabilityModeEnum } from '../../../shared/modules/vehicle-categories/enums/vehicle-category-availability-mode.enum';
import { DiscountConfigurationMode } from '../../../shared/modules/vehicle-categories/enums/discount-configuration-mode.enum';
import { VehicleCategoryTypeEnum } from '../../../shared/modules/vehicle-categories/enums/vehicle-category-type.enum';
import { VehicleCategoryFeatureItemDto } from '../../../shared/modules/vehicle-category-feature-items/dtos/vehicle-category-feature-item.dto';
import { VehicleCategoryPricingItemPresetDto } from '../../../shared/modules/vehicle-category-pricing-item-presets';

/**
 * Vehicle category DTO for searchable fields
 */
@CaslSubject(AppSubjectEnum.VEHICLE_CATEGORY)
export class VehicleCategorySearchDto extends BaseSearchDto {
  name!: string;
  type!: VehicleCategoryTypeEnum;
  availabilityMode?: VehicleCategoryAvailabilityModeEnum | null;
  depositPercentage?: number | null;
  depositFlatRate?: number | null;
  standardDiscountPercentage?: number | null;
  discountConfigurationMode?: DiscountConfigurationMode | null;
  excessAmount?: number | null;
  reducedExcessAmount?: number | null;
  minAgeLimit?: number | null;
  youngDriverAgeLimit?: number | null;
  maxAgeLimit?: number | null;
  seniorAgeLimit?: number | null;
  minDrivingYears?: number | null;
  featureItems?: VehicleCategoryFeatureItemDto[] | null;
  pricingTierItems?: PricingTierItemDto[] | null;
  pricingItemPresets?: VehicleCategoryPricingItemPresetDto[] | null;
  files?: FileDto[] | null;
}
